<div class="flex-spaced" *ngIf="showFilter">
  <div>
    <h2 *ngIf="title != null">{{title}} ({{increment}})</h2>
  </div>
  <app-select-input *ngIf="datasetPropertyOptions != null" [(ngModel)]="propertyToChart" 
    (changed)="refresh()" [options]="datasetPropertyOptions"></app-select-input>
</div>
<canvas baseChart [type]="chartType" [data]="chartData" [options]="chartOptions" class="chart"></canvas>
